const TONE = {
  lead: "border-amber-300/60 bg-amber-400/20 text-amber-50",
  partner: "border-sky-300/60 bg-sky-500/20 text-sky-50",
  both: "border-violet-300/60 bg-violet-500/25 text-violet-50",
  choir: "border-emerald-300/60 bg-emerald-500/20 text-emerald-50",
  call_response: "border-violet-300/60 bg-violet-500/25 text-violet-50",
};

/** Who sings each [section] of the lyrics. */
export default function PartsEditor({ parts, singers, onChange }) {
  if (!parts.length) {
    return (
      <p data-testid="parts-empty" className="rounded-2xl border border-dashed border-white/15 px-4 py-3 text-[12px] text-white/55">
        Add section tags like <span className="font-mono text-white/80">[Verse 1]</span> and <span className="font-mono text-white/80">[Chorus]</span> to your lyrics to choose who sings each part.
      </p>
    );
  }
  const setSinger = (i, singer) => onChange(parts.map((p, k) => (k === i ? { ...p, singer } : p)));
  return (
    <div data-testid="parts-editor" className="space-y-1.5">
      <p className="font-mono text-[10px] uppercase tracking-[0.16em] text-white/55">Who sings each part</p>
      {parts.map((p, i) => (
        <div key={`${p.label}-${i}`} data-testid={`part-row-${i}`} className="flex flex-wrap items-center justify-between gap-2 rounded-xl bg-white/[0.03] px-3 py-2">
          <span className="font-display text-[13px] font-semibold text-white/85">{p.label}</span>
          <div role="radiogroup" aria-label={`${p.label} singer`} className="flex flex-wrap gap-1">
            {singers.map((s) => (
              <button key={s.key} type="button" role="radio" aria-checked={p.singer === s.key} data-testid={`part-${i}-${s.key}`} onClick={() => setSinger(i, s.key)}
                className={`rounded-full border px-2.5 py-1 font-mono text-[10px] uppercase tracking-wider transition-colors ${p.singer === s.key ? TONE[s.key] : "border-white/10 text-white/50 hover:text-white"}`}>
                {s.label}
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
